import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Modal, Button, Spin } from 'antd'
import { history } from 'umi'
import omit from 'lodash/omit'

import { useSelector } from 'dva'
import { createAPI } from '@/utils/modal'
import styles from './index.less'

import { queryDocumentsDetail } from '@/services/helpDocuments'
import { register } from '@/utils/scheduler'
const WHITE_LIST = [/^(https|http):\/\/jushuitan\.yuque\.com/]

const validateUrl = url => {
    return WHITE_LIST.some(v => v.test(url))
}

export let dialog = null

const Loading = ({ iframe }) => {
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (iframe.current) {
            iframe.current.onload = () => {
                setLoading(false)
            }
        }
    }, [iframe.current])

    if (loading) {
        return (
            <div className={styles.mask}>
                <Spin />
            </div>
        )
    }

    return null
}

const Iframe = ({ url }) => {
    const $iframe = useRef(null)

    return (
        <div className={styles.container}>
            <iframe
                className={styles.iframe}
                ref={$iframe}
                src={url}
                frameBorder="0"
                allow="clipboard-read; clipboard-write"
            />
            <Loading iframe={$iframe} />
        </div>
    )
}

// 改变富文本图片链接
const changeImgSrc = str => {
    return (
        str &&
        str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture, r) => {
            return (
                match &&
                match.replace(/src=['"]([^'"]+)[^>]*?/g, src => {
                    let cap = capture.indexOf('images.sursung.com') > -1 || capture.indexOf('assets.sursung.com') > -1
                    let isOss = `${
                        /.gif$/.test(src) ? src : `${src}?x-oss-process=image/resize,m_mfit,w_2000/format,jpg`
                    }`
                    return cap ? isOss : src
                })
            )
        })
    )
}

export const openInnerWindow = async ({ doc, onClose, afterClose }) => {
    const props = {
        closable: false,
        forceRender: true,
        zIndex: 10080,
        className: styles.modal,
        maskStyle: { transition: 'none' },
        getContainer: () => document.getElementById('root'),
        getCustomContainer: () => document.getElementById('root'),
        footer: <Button onClick={onClose}>关闭</Button>,
        width: '70%',
        style: { top: '6%', transition: 'none' },
        bodyStyle: { padding: 0 },
        afterClose: () => {
            dialog = null
            afterClose?.()
        }
    }

    const openDialog = curProps => {
        if (dialog) {
            dialog.update(curProps)
        } else {
            const { setFinishFlag } = register({
                timeout: 1000,
                priority: 0,
                needComplete: true,
                execContent: () => {
                    dialog = createAPI(Modal, {
                        ...curProps,
                        afterClose: () => {
                            dialog = null
                            afterClose?.()
                            setFinishFlag(true)
                        }
                    })
                }
            })
        }
    }

    // 地址
    if (validateUrl(doc)) {
        const curProps = {
            ...props,
            children: <Iframe src={doc} />
        }

        openDialog(curProps)
    } else {
        const { success, data } = await queryDocumentsDetail({
            id: doc
        })
        if (success && data) {
            const curProps = {
                ...props,
                closable: false,
                children: (
                    <div
                        className={styles.container}
                        style={{ padding: '10px 24px', overflowY: 'auto' }}
                        dangerouslySetInnerHTML={{ __html: changeImgSrc(data.text) }}
                    />
                )
            }

            openDialog(curProps)
        } else {
            return Promise.reject(new Error('获取文档内容失败'))
        }
    }
}

export default ({ location }) => {
    const { query } = location || {}
    const { doc = '' } = query || {}

    const init = useCallback(() => {
        if (doc) {
            openInnerWindow({
                doc: decodeURIComponent(doc),
                onClose() {
                    dialog && dialog.close()
                },
                afterClose() {
                    dialog = null
                }
            })

            history.replace({
                pathname: location.pathname,
                query: omit(location.query, ['doc'])
            })
        } else {
            dialog && dialog.close()
        }

        return () => {
            dialog && dialog.close()
        }
    }, [doc])

    const uid = useSelector(state => state?.user?.currentUser?.uid)

    useEffect(() => {
        if (uid) {
            init()
        }
    }, [uid, init])
}
